module.exports = __webpack_public_path__ + "img/scene1-7.7e932a0f.png";